import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getBrandingCatalog } from "../../services/brandingService";
import IconsTab from "./IconsTab";
import CouponsTab from "./CouponsTab";
import { BRAND, PAGE_BG, CARD_BORDER } from "./shared";

const TABS = [
  { key: "icons", label: "Icons" },
  { key: "coupons", label: "Coupons" },
];

// Vendor portal "Branding & Offers": icons for services / categories / service
// types, plus the vendor's own coupons. Images are stored in S3 under
// the vendor's own folder (vendors/<vendorId>/...).
export default function BrandingOffers() {
  const [tab, setTab] = useState("icons");
  const [catalog, setCatalog] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCatalog = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getBrandingCatalog();
      setCatalog(res?.data || []);
    } catch (e) {
      toast.error(e?.message || "Could not load your services");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadCatalog(); }, [loadCatalog]);

  // Update one icon in place after an upload, without reloading the list.
  const onIconSaved = (level, id, icon) =>
    setCatalog((cat) =>
      cat.map((s) => {
        if (level === "service") return s.id === id ? { ...s, icon } : s;
        return {
          ...s,
          other_types: level === "type" ? (s.other_types || []).map((t) => (t.id === id ? { ...t, icon } : t)) : s.other_types,
          categories: s.categories.map((c) => {
            if (level === "category") return c.id === id ? { ...c, icon } : c;
            return { ...c, types: c.types.map((t) => (t.id === id ? { ...t, icon } : t)) };
          }),
        };
      })
    );

  return (
    <div style={{ background: PAGE_BG, minHeight: "100vh", padding: "20px 24px" }}>
      <div style={{ marginBottom: 18 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#0f172a" }}>Branding &amp; Offers</h2>
        <p style={{ margin: "4px 0 0", color: "#94a3b8", fontSize: 13 }}>
          Your icons and coupons
        </p>
      </div>

      <div style={{ display: "flex", gap: 6, marginBottom: 18, borderBottom: `1px solid ${CARD_BORDER}` }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            style={{
              border: "none", background: "none", padding: "10px 18px", cursor: "pointer", fontSize: 14,
              fontWeight: tab === t.key ? 700 : 500, color: tab === t.key ? BRAND : "#64748b",
              borderBottom: `2px solid ${tab === t.key ? BRAND : "transparent"}`, marginBottom: -1,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "icons" && <IconsTab catalog={catalog} loading={loading} onIconSaved={onIconSaved} />}
      {tab === "coupons" && <CouponsTab catalog={catalog} />}
    </div>
  );
}
